export { default } from "./AppHeaderBurgerMenuLink";
export type { BurgerMenuLink } from "./AppHeaderBurgerMenuLink";
